module.exports = __webpack_public_path__ + "img/domain.6b46849f.svg";